import {graphql} from "babel-plugin-relay/macro";

export const CLONE_TREE_MUTATION = graphql`
    mutation projectCloneTreeButton_CloneTreeUsingAPredefinedTemplateAdminMutation(
        $input: CloneTreeUsingAPredefinedTemplateInput!
        $connections: [ID!]!
    ) {
        Admin {
            Tree {
                cloneTreeUsingAPredefinedTemplate(input: $input) {
                    clonedRootNode @appendEdge(connections: $connections) {
                        node {
                            id
                            ...RootNodesTable_TreeNodeFragment
                        }
                    }
                }
            }
        }
    }
`;
